class MuuvRelaunchSale extends HTMLElement {
  connectedCallback() {
    const dialog = this.querySelector('[data-muuv-relaunch-sale-dialog]');
    const closeButton = this.querySelector('[data-muuv-relaunch-sale-close]');
    if (!(dialog instanceof HTMLDialogElement) || !closeButton) return;

    const storageKey = 'muuv-relaunch-sale-dismissed';
    const dismiss = () => {
      try { sessionStorage.setItem(storageKey, 'true'); } catch (_) { /* Storage may be unavailable. */ }
      if (dialog.open) dialog.close();
    };

    closeButton.addEventListener('click', dismiss);
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dismiss();
    });
    dialog.addEventListener('cancel', () => {
      try { sessionStorage.setItem(storageKey, 'true'); } catch (_) { /* Storage may be unavailable. */ }
    });

    let dismissed = false;
    try { dismissed = sessionStorage.getItem(storageKey) === 'true'; } catch (_) { /* Storage may be unavailable. */ }
    if (!dismissed) window.requestAnimationFrame(() => dialog.showModal());
  }
}

if (!customElements.get('muuv-relaunch-sale')) {
  customElements.define('muuv-relaunch-sale', MuuvRelaunchSale);
}
